// extracted by mini-css-extract-plugin
export var container = "styles-module--container--1d3af";
export var hideText = "styles-module--hideText--154c0";
export var position = "styles-module--position--ded2f";
export var rightSide = "styles-module--rightSide--e691b";
export var swipeRight = "styles-module--swipe-right--c0be3";
export var textContent = "styles-module--textContent--475ac";
export var textPadding = "styles-module--textPadding--660a1";
export var variant1 = "styles-module--variant1--ae400";
export var variant2 = "styles-module--variant2--0ec7f";